// extracted by mini-css-extract-plugin
export default {"EmptyState":"BillInvoiceList_EmptyState__Mnb+b"};